import { render, staticRenderFns } from "./HeaderNotification.vue?vue&type=template&id=058900c1&scoped=true&"
import script from "./HeaderNotification.vue?vue&type=script&lang=js&"
export * from "./HeaderNotification.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNotification.vue?vue&type=style&index=0&id=058900c1&lang=scss&scoped=true&"
import style1 from "./HeaderNotification.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058900c1",
  null
  
)

export default component.exports